<template>
	<div>
		<div class="inbox">
			<bsf-page-header>
				<h3 slot="header">swiper 组件</h3>
			</bsf-page-header>
			<breadcrumb :data="$store.state.bcArray"></breadcrumb>
		</div>
		<bsf-col size="xs" col="6">
			<bsf-panel header="swiper竖向">
				<swiper slot="body" :data="swiperData" direction="vertical" height="300"></swiper>
			</bsf-panel>
		</bsf-col>
		<bsf-col size="xs" col="6">
			<bsf-panel header="swiper横向">
				<swiper slot="body" :data="swiperData" height="300" showArrow></swiper>
			</bsf-panel>
		</bsf-col>
		<bsf-col size="xs" col="6">
			<bsf-panel header="swiper自动播放 3s">
				<swiper slot="body" :data="swiperData" height="300" autoPlay="3000"></swiper>
			</bsf-panel>
		</bsf-col>
		<bsf-col size="xs" col="6">
			<bsf-panel header="swiper自动播放 5s">
				<swiper slot="body" :data="swiperData" height="300" autoPlay="5000"></swiper>
			</bsf-panel>
		</bsf-col>
		<bsf-col size="xs" col="4">
			<bsf-panel header="fade效果">
				<swiper slot="body" :data="swiperData" height="200" effect="fade" autoPlay="5000"></swiper>
			</bsf-panel>
		</bsf-col>
		<bsf-col size="xs" col="4">
			<bsf-panel header="cube效果">
				<swiper slot="body" :data="swiperData" height="200" effect="cube" autoPlay="5000"></swiper>
			</bsf-panel>
		</bsf-col>
		<bsf-col size="xs" col="4">
			<bsf-panel header="flip效果">
				<swiper slot="body" :data="swiperData" height="200" effect="flip" autoPlay="5000"></swiper>
			</bsf-panel>
		</bsf-col>
		<bsf-col size="xs" col="6">
			<bsf-panel header="keyboardControl">
				<swiper slot="body" :data="swiperData" height="300" keyboard></swiper>
			</bsf-panel>
		</bsf-col>
		<bsf-col size="xs" col="6">
			<bsf-panel header="mousewheelControl">
				<swiper slot="body" :data="swiperData" height="300" mouse></swiper>
			</bsf-panel>
		</bsf-col>
		<bsf-col size="xs" col="4">
			<bsf-panel header="设置显示个数">
				<swiper slot="body" :data="swiperData" height="300" mouse :pv="2"></swiper>
			</bsf-panel>
		</bsf-col>
		<bsf-col size="xs" col="4">
			<bsf-panel header="设置显示个数 分组">
				<swiper slot="body" :data="swiperData" height="300" mouse :pv="2" :pg="2"></swiper>
			</bsf-panel>
		</bsf-col>
		<bsf-col size="xs" col="4">
			<bsf-panel header="设置显示个数 间距">
				<swiper slot="body" :data="swiperData" height="300" mouse :pv="3" :st="30"></swiper>
			</bsf-panel>
		</bsf-col>
	</div>
</template>
<script>
	import bsfLayout from "components/css/layout"
	import bsfCol from "components/css/col"
	//
	import bsfPanel from 'components/comp/panel'
	import bsfPageHeader from 'components/comp/pageheader'
	import breadcrumb from 'components/comp/breadcrumbs'
	import swiper from 'components/comp/swiper'
	//
	export default {
		components: {
			bsfLayout,
			bsfCol,
			//
			bsfPageHeader,
			breadcrumb,
			bsfPanel,
			swiper
		},
		data() {
			return {
				swiperData: [{
					name: "lopo",
					tit: "tit"
				}, {
					name: "lopo1",
					tit: "tit1"
				}, {
					name: "lopo2",
					tit: "tit2"
				}, {
					name: "lopo3",
					tit: "tit3"
				}],
				navdata1: [{
					name: "Home",
					href: ""
				}, {
					name: "Profile",
					href: ""
				}, {
					name: "Message",
					href: "",
					active: true
				}],
			}
		}
	}
</script>


// WEBPACK FOOTER //
// swiper.vue?24602ced